import { actionTypes } from "../actions/BulkEditAction";
import { SortTypes } from "../../util/table-view/TableTypes";
import { defaultResultsPerPage } from "../Types";

const initialState = {
  totalItems: 0,
  job: {
    job_id: null,
    selected_tracks: [],
    selected_albums: [],
    albumTracksProdId: [],
    track_common_updates: {},
    track_specific_updates: {},
    album_common_updates: {},
    album_specific_updates: {},
    type: null,
    session_name: null,
    org_id: null,
  },
  validationErrors: {
    track_common_validation: {},
    track_specific_validation: {},
    album_common_validation: {},
    album_specific_validation: {},
  },

  loading: false,
  listOfCountries: [],
  listOfOrigins: [],
  listOfDecades: [],
  listOfVocals: [],
  listOfAlbumTypes: [],
  currentTrackId: null,
  currentAlbumId: null,
  loadingMore: false,
  posting: { busy: false, message: "", errors: null },
  sessionName: "",
  exportingMessage: "",
  noMore: true,
  editing: null,
  albumEditing: null,
  disabledField: false,
  isTrackDataEmpty: false,
  isAlbumDataEmpty: false,
  query: {
    order: SortTypes.desc,
    orderBy: "date_last_edited",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
  },
  errors: null,

  trackCommonEditing: {
    prodArtist: null,
    composer: null,
    publisher: null,
    recordLabel: null,
    style: null,
    duration: null,
    disk: null,
    cd: null,
    org_sky_Area: null,
    org_sky_LibrarianNotes: null,
    tempo: null,
    bpm: null,
    trackVersionTitle: null,
    org_sky_Decade: null,
    org_sky_Vocal: null,
    recording_year: null,
    tags: null,
    org_sky_Lyrics: null,
    isrc: null,
    iswc: null,
    org_sky_MCPSID: null,
    trackNotes: null,
    prodDiscNr: null,
    org_sky_RecordingYear: null,
    org_sky_SingleReleaseDate: null,
    org_sky_SingleChartPosition: null,
    musicOrigin: null,
    org_sky_Subtitle: null,
    org_sky_Country: null,
    org_sky_IsSingleRelease: null,
    org_sky_DownloadAvailable: null,
    org_sky_IsLibraryRecommended: null,
    org_sky_PPL: null,
    org_sky_MCPS: null,
  },

  albumCommonEditing: {
    prodSubtitle: null,
    Catalog: null,
    prodArtist: null,
    prodNumberOfDiscs: null,
    org_sky_ReleaseDate: null,
    org_sky_CompanyDetails: null,
    org_sky_TownCityState: null,
    org_sky_Country: null,
    org_sky_NumberMedia: null,
    org_sky_Plugger1: null,
    org_sky_ChartPosition: null,
    ipRecordLabel: null,
    org_sky_SocialSite: null,
    org_sky_AlbumTypeID: null,
    org_sky_LibrarianNotes: null,
    prodRelease: null,
    org_sky_Vocal: null,
    org_sky_ArtistWebsite: null,
    org_sky_LabelWebsite: null,
    org_sky_Publisher: null,
    org_sky_Company: null,
    org_sky_IsMCPSBlanket: null,
    org_sky_IsPPLBlanket: null,
    prodNotes: null,
  },
};

export default function (state = initialState, action) {
  const { currentTrackId, currentAlbumId } = state;

  const isDisabledField = (validationErrors) =>
    Object.keys(validationErrors.track_common_validation ?? {}).length > 0 ||
    Object.keys(
      validationErrors.track_specific_validation?.[currentTrackId] ?? {}
    ).length > 0 ||
    Object.keys(validationErrors.album_common_validation ?? {}).length > 0 ||
    Object.keys(
      validationErrors.album_specific_validation?.[currentAlbumId] ?? {}
    ).length > 0;

  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        isTrackDataEmpty: false,
        isAlbumDataEmpty: false,
        exportingMessage: action.payload,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        editing: action.payload,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.ALBUM_TRACK_LOAD:
      return {
        ...state,
        loading: false,
        albumTracksProdId: action.payload,
      };

    case actionTypes.CURRENT_TRACK_ID:
      return {
        ...state,
        currentTrackId: action.payload,
      };

    case actionTypes.CURRENT_ALBUM_ID:
      return {
        ...state,
        currentAlbumId: action.payload,
      };

    case actionTypes.ALBUM_LOAD:
      return {
        ...state,
        loading: false,
        albumEditing: action.payload,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.POSTING:
      return {
        ...state,
        exportingMessage: action.payload,
        loading: true,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.POST_OK_MESSAGE:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };
    case actionTypes.POST_OK:
      return {
        ...state,
        loading: false,
        disabledField: isDisabledField({}),

        sessionName: action.payload.session_name,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.IMAGE_POST_OK:
      return {
        ...state,
        loading: false,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.POST_PUBLISH:
      return {
        ...state,
        loading: false,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.INVOKE_OK:
      return {
        ...state,
        loading: false,
        job: action.payload,
        sessionName: action.payload.session_name,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.BULK_EDIT_SAVING:
      return {
        ...state,
        loading: false,
        job: action.payload,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.GET_COUNTRIES:
      return {
        ...state,
        loading: false,
        listOfCountries: action.payload ? action.payload : "",
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.GET_ORIGINS:
      return {
        ...state,
        loading: false,
        listOfOrigins: action.payload ? action.payload : "",
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.GET_DECADES:
      return {
        ...state,
        loading: false,
        listOfDecades: action.payload ? action.payload : "",
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.GET_VOCALS:
      return {
        ...state,
        loading: false,
        listOfVocals: action.payload ? action.payload : "",
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.ALBUM_TYPES:
      return {
        ...state,
        loading: false,
        listOfAlbumTypes: action.payload ? action.payload : "",
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };

    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.COMMON_EDIT_ITEM:
      return {
        ...state,
        commonEditing: action.payload,
      };

    case actionTypes.ALBUM_EDIT_ITEM:
      return {
        ...state,
        albumEditing: action.payload,
      };

    case actionTypes.ALBUM_COMMON_EDIT_ITEM:
      return {
        ...state,
        albumCommonEditing: action.payload,
      };

    case actionTypes.JOB_EDIT_ITEM:
      return {
        ...state,
        job: action.payload,
      };

    case actionTypes.VALIDATION_ITEM:
      return {
        ...state,
        disabledField: isDisabledField(action.payload),
        validationErrors: action.payload,
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: true,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.SET_ERROR:
      return {
        ...state,
        disabledField: true,
        posting: {
          busy: true,
          message: null,
          errors: action.payload,
        },
      };

    case actionTypes.STOP_ERROR:
      return {
        ...state,
        loading: false,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: action.payload,
        noMore: true,
      };

    case actionTypes.TRACK_DATA:
      return {
        ...state,
        loading: false,
        isTrackDataEmpty: true,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };
    case actionTypes.ALBUM_DATA:
      return {
        ...state,
        loading: false,
        isAlbumDataEmpty: true,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    default:
      return state;
  }
}